import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

const SELECTED_MODULE_KEY = "participant:selectedModule";

const ModulePlayer = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const trackerId = searchParams.get("trackerId") || "";
  const learningPathId = searchParams.get("learningPathId") || "";
  const courseId = searchParams.get("courseId") || "";

  const currentModule = (() => {
    try {
      const raw = sessionStorage.getItem(SELECTED_MODULE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  })();

  const modulePath = currentModule?.modulePath;

  return (
    <div className="max-w-[1200px]">
      <button
        type="button"
        onClick={() =>
          navigate(
            `/participant/courses-and-learning-path/${trackerId}/${learningPathId}/courses/${courseId}?trigger=1`
          )
        }
        className="inline-flex items-center gap-2 text-sm text-[#0A3059] mb-4"
      >
        <FiArrowLeft /> Back to Course
      </button>

      {!modulePath ? (
        <div className="bg-white border border-gray-100 rounded-xl p-4 text-sm text-gray-600">
          Module launch URL was not returned by the server. Please start the module again.
        </div>
      ) : (
        <div className="bg-white border border-gray-100 rounded-xl overflow-hidden">
          <div className="px-3 py-2 border-b border-gray-100">
            <p className="text-sm font-semibold text-[#0A3059]">
              {currentModule?.title || "Module Player"}
            </p>
          </div>
          <iframe
            title={currentModule?.title || "Module Player"}
            src={modulePath}
            className="w-full h-[72vh]"
            allow="fullscreen; autoplay"
          />
        </div>
      )}
    </div>
  );
};

export default ModulePlayer;
